/**
 * 將 tree 攤平
 */
export function flattenSeriesTree(tree) {
    const result = [];

    const traverse = (nodes) => {
        for (const node of nodes) {
            const { children, ...rest } = node;
            result.push(rest);
            if (children?.length) {
                traverse(children);
            }
        }
    };

    traverse(tree);
    return result;
}
